
function Expertise(){

    $('.expertise-list__select').on('click', function(){
        $('.expertise-teaser').slideToggle();
    });

}